import { Box, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AuthHeader } from '@/components/layout';
import { InvalidLinkCard } from '@/features/auth/components/InvalidLinkCard';

export const VerifyEmailExpiredPage = () => {
  const { t } = useTranslation();

  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <InvalidLinkCard
          title={t('verifyEmail.expiredTitle')}
          message={t('verifyEmail.expiredMessage')}
          hint={t('verifyEmail.expiredHint')}
          retryLabel={t('verifyEmail.expiredRetry')}
          retryTo="/register"
          backTo="/login"
        />
      </Center>
    </Box>
  );
};
